import { useLocation } from "react-router-dom";
import { Breadcrumbs, Typography } from "@mui/material";
import { ReactComponent as IconChevronRight } from "assets/svg/chevron_right.svg";
import { sidenavData } from "layouts/Sidenav/const";
import { findBreadcrumbsByPath } from "./const";

export const BreadcrumbsHeader = () => {
  const { pathname } = useLocation();

  const breadcrumbsData = findBreadcrumbsByPath(sidenavData, pathname);

  return (
    <Breadcrumbs
      sx={{ ol: { flexWrap: "nowrap" } }}
      separator={<IconChevronRight />}
    >
      {breadcrumbsData.map((item, index) => (
        <Typography
          key={index}
          variant="h5"
          sx={({ palette, typography }) => ({
            color:
              breadcrumbsData.length === index + 1
                ? palette.text.textLink
                : palette.text.textPrimary,
            fontWeight: typography.fw_semibold_500,
            whiteSpace: "nowrap",
          })}
        >
          {item.label}
        </Typography>
      ))}
    </Breadcrumbs>
  );
};

export default BreadcrumbsHeader;
